import axios from "axios";
import Config from "config";

const sendForm = (data, companyID) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/add-form`, {
        data,
        companyID,
      })
      .then((res) => res.data)
      .then((sendFormResponse) => resolve(sendFormResponse))
      .catch((error) => console.log(error));
  });
};

export default { sendForm };
